import React from "react";
import RfpHelpPopover from "./RfpHelpPopover";

const inputCls =
  "min-h-[36px] rounded-lg border border-slate-300 bg-white px-2.5 py-1.5 text-sm dark:border-slate-600 dark:bg-slate-900";

export default function RfpReviewFilterRow({
  search,
  onSearchChange,
  techFilter,
  onTechFilterChange,
  technologies,
  classFilter,
  onClassFilterChange,
  classes,
  classLabel,
  reviewFilter,
  onReviewFilterChange,
  reviewChips,
  showToc,
  onShowTocChange,
  hiddenTocCount,
  showExcluded,
  onShowExcludedChange,
  hiddenFocusCount,
  autosaving,
}) {
  return (
    <div
      data-testid="rfp-review-filter-row"
      className="flex flex-wrap items-center gap-1.5 lg:flex-nowrap"
    >
      <input
        type="search"
        data-testid="rfp-search-input"
        placeholder="Search text…"
        className={`${inputCls} w-full min-w-[12rem] max-w-md shrink-0 lg:max-w-[28rem]`}
        value={search}
        onChange={(e) => onSearchChange(e.target.value)}
      />
      <select
        data-testid="rfp-product-filter"
        className={`${inputCls} w-[10.5rem] shrink-0`}
        value={techFilter}
        onChange={(e) => onTechFilterChange(e.target.value)}
      >
        <option value="">All products</option>
        {technologies.map((t) => (
          <option key={t} value={t}>
            {t}
          </option>
        ))}
      </select>
      <select
        data-testid="rfp-class-filter"
        className={`${inputCls} w-[10.5rem] shrink-0`}
        value={classFilter}
        onChange={(e) => onClassFilterChange(e.target.value)}
      >
        <option value="">All classes</option>
        {classes.map((c) => (
          <option key={c} value={c}>
            {classLabel(c)}
          </option>
        ))}
      </select>
      <div className="flex flex-wrap items-center gap-1" data-testid="rfp-quick-filters">
        {reviewChips.map((chip) => (
          <button
            key={chip.id || "all"}
            type="button"
            data-testid={`rfp-quick-filter-${chip.id || "all"}`}
            onClick={() => onReviewFilterChange(chip.id)}
            className={`rounded-md px-2 py-1 text-xs font-medium transition ${
              reviewFilter === chip.id
                ? "bg-slate-800 text-white dark:bg-slate-600"
                : "border border-slate-300 bg-white text-slate-600 hover:border-slate-400 dark:border-slate-600 dark:bg-slate-900 dark:text-slate-300"
            }`}
          >
            {chip.label}
          </button>
        ))}
        <button
          type="button"
          data-testid="rfp-toggle-toc"
          onClick={() => onShowTocChange?.(!showToc)}
          className={`rounded-md px-2 py-1 text-xs font-medium transition ${
            showToc
              ? "bg-slate-800 text-white dark:bg-slate-600"
              : "border border-slate-300 bg-white text-slate-600 hover:border-slate-400 dark:border-slate-600 dark:bg-slate-900 dark:text-slate-300"
          }`}
        >
          {showToc ? "Hide TOC" : hiddenTocCount ? `Show TOC (${hiddenTocCount})` : "Show TOC"}
        </button>
        <button
          type="button"
          data-testid="rfp-toggle-excluded"
          onClick={() => onShowExcludedChange?.(!showExcluded)}
          className={`rounded-md px-2 py-1 text-xs font-medium transition ${
            showExcluded
              ? "bg-slate-800 text-white dark:bg-slate-600"
              : "border border-slate-300 bg-white text-slate-600 hover:border-slate-400 dark:border-slate-600 dark:bg-slate-900 dark:text-slate-300"
          }`}
        >
          {showExcluded
            ? "Hide excluded"
            : hiddenFocusCount
              ? `Show excluded (${hiddenFocusCount})`
              : "Show excluded"}
        </button>
      </div>
      <div className="ml-auto flex items-center gap-2">
        <RfpHelpPopover />
        {autosaving ? <span className="text-xs text-slate-500">Auto-saving comments…</span> : null}
      </div>
    </div>
  );
}
